import React from 'react';
import { Jumbotron as Jumbo, Container } from 'react-bootstrap';
import {Layout} from './components/Layout';
import {Jumbotron} from './components/Jumbotron6';
import styled from 'styled-components';

const Styles =styled.div`
.stuff{
font-family: 'Open Sans', sans-serif;
margin-bottom:100px;
margin-left:15px;
margin-right:15px;
}

.text{
margin-left:30px;
font-family: 'Open Sans', sans-serif;
font-size: 24px;
margin-right:40px;
margin-top:80px;


`;
export const Resume = ()=> (
<React.Fragment>
<Jumbotron />
	
		<Styles>
	<body>
<div class="text">
<p>Because I'm still figuring out how to upload files, you can find my resume on Github by going to <a href="https://github.com/jaytopiwala/portfolio/wiki/Jay-Topiwala-Resume/"target="_blank">this link</a>.</p>
</div>
</body>
</Styles>
</React.Fragment>
) 